import * as marietta from '../../..';

/**
 * 窓テクスチャメニュークラス
 */
export default class SashColorMenu {
  viewObj: Element;

  tabEntrance: Element;

  tabSash: Element;

  tabGarage: Element;

  /**
   * コンストラクタ
   */
  constructor() {
    this.viewObj = document.getElementById('itemChangeMenu_sash');
    this.tabEntrance = document.getElementById('tabEntrance');
    this.tabSash = document.getElementById('tabSash');
    this.tabGarage = document.getElementById('tabGarage');
  }

  /**
   * 初期化
   */
  init() {
    this.viewObj.querySelectorAll('.tabContents').forEach((elem) => {
      const tabcontLen = elem.children.length;
      if (tabcontLen > 0) {
        for (let i = 0; i < tabcontLen; i += 1) {
          elem.children[0].remove();
        }
      }
    });
    this.createMaterialList();

    this.viewObj.querySelectorAll('.tabMenu').forEach((elem) => {
      elem.querySelectorAll('label')[0].click();
    });
  }

  /**
   * カラー（テクスチャ）リストの生成
   */
  createMaterialList() {
    let contents: string = '';
    // 情報をGET
    const entryData = marietta.view3d.webcad.View3dGlobal.shared.getMaterialList(marietta.view3d.webcad.ItemType.Entry);
    const sashData = marietta.view3d.webcad.View3dGlobal.shared.getMaterialList(marietta.view3d.webcad.ItemType.Sash);
    const garageData = marietta.view3d.webcad.View3dGlobal.shared.getMaterialList(marietta.view3d.webcad.ItemType.Garage);

    // コンテンツの作成
    contents = '';
    contents += '<ul>';
    if (entryData !== undefined) {
      for (let i = 0; i < entryData.length; i += 1) {
        contents += `<li data-itemindex="${String(i)}" class="btnChangeItemColor" data-itemtype="0" ><button id="changeFitColorEnt${String(i)}"><p class="texture" style="background:#${entryData[i].color}"/><div class="currentFrame"></div><p>${entryData[i].name}</p></button></li>`;
      }
    }
    contents += '</ul>';
    this.tabEntrance.insertAdjacentHTML('beforeend', contents);

    // コンテンツの作成
    contents = '';
    contents += '<ul>';
    if (sashData !== undefined) {
      for (let i = 0; i < sashData.length; i += 1) {
        contents += `<li data-itemindex="${String(i)}" class="btnChangeItemColor" data-itemtype="2" ><button id="changeFitColorWindow${String(i)}"><p class="texture" style="background:#${sashData[i].color}"/><div class="currentFrame"></div><p>${sashData[i].name}</p></button></li>`;
      }
    }
    contents += '</ul>';
    this.tabSash.insertAdjacentHTML('beforeend', contents);

    // コンテンツの作成
    contents = '';
    contents += '<ul>';
    if (garageData !== undefined) {
      for (let i = 0; i < garageData.length; i += 1) {
        contents += `<li data-itemindex="${String(i)}" class="btnChangeItemColor" data-itemtype="9" ><button id="changeFitColorWindow${String(i)}"><p class="texture" style="background:#${garageData[i].color}"/><div class="currentFrame"></div><p>${garageData[i].name}</p></button></li>`;
      }
    }
    contents += '</ul>';
    this.tabGarage.insertAdjacentHTML('beforeend', contents);
    document.querySelectorAll('.btnChangeItemColor').forEach((elem) => {
      elem.addEventListener('click', (e) => {
        const itemIndex = Number(((e.currentTarget) as HTMLElement).getAttribute('data-itemindex'));
        const itemType = Number(((e.currentTarget) as HTMLElement).getAttribute('data-itemtype'));
        marietta.view3d.webcad.View3dGlobal.shared.changeItemColor(itemType, itemIndex);
      });
    });
    // カレントを表示
    this.initCurrentTexture();

    const self = this;
    (self.tabEntrance).querySelectorAll('li').forEach((elem) => {
      elem.addEventListener('click', self.updateCurrentTexture);
    });
    (self.tabSash).querySelectorAll('li').forEach((elem) => {
      elem.addEventListener('click', self.updateCurrentTexture);
    });
    (self.tabGarage).querySelectorAll('li').forEach((elem) => {
      elem.addEventListener('click', self.updateCurrentTexture);
    });
  }

  /**
   * 選択状態の更新
   */
  initCurrentTexture() {
    // 情報をGET
    const entryData: marietta.view3d.webcad.w3dItemInfo[] = marietta.view3d.webcad.View3dGlobal.shared.getMaterialList(marietta.view3d.webcad.ItemType.Entry);
    const sashData: marietta.view3d.webcad.w3dItemInfo[] = marietta.view3d.webcad.View3dGlobal.shared.getMaterialList(marietta.view3d.webcad.ItemType.Sash);
    const garageData: marietta.view3d.webcad.w3dItemInfo[] = marietta.view3d.webcad.View3dGlobal.shared.getMaterialList(marietta.view3d.webcad.ItemType.Garage);

    const self = this;
    entryData.forEach((obj, index) => {
      if (obj.selected) {
        (self.viewObj).querySelector('#tabEntrance').querySelectorAll('li')[index].classList.add('is-active');
      } else {
        (self.viewObj).querySelector('#tabEntrance').querySelectorAll('li')[index].classList.remove('is-active');
      }
    });

    sashData.forEach((obj, index) => {
      if (obj.selected) {
        (self.viewObj).querySelector('#tabSash').querySelectorAll('li')[index].classList.add('is-active');
      } else {
        (self.viewObj).querySelector('#tabSash').querySelectorAll('li')[index].classList.remove('is-active');
      }
    });

    garageData.forEach((obj, index) => {
      if (obj.selected) {
        (self.viewObj).querySelector('#tabGarage').querySelectorAll('li')[index].classList.add('is-active');
      } else {
        (self.viewObj).querySelector('#tabGarage').querySelectorAll('li')[index].classList.remove('is-active');
      }
    });
  }

  /**
   * 選択中のテクスチャをカレント表示
   */
  updateCurrentTexture = (e) => {
    (e.currentTarget).closest('ul').querySelectorAll('li').forEach((elem) => {
      elem.classList.remove('is-active');
    });
    (e.currentTarget).classList.add('is-active');
  }
}
